







































































































































































































































































































































































































import { Vue, Component, Prop , Watch, Emit} from 'vue-property-decorator';
import './gisEmapPanelEdit.less';
import { Drag } from './toDrag';
@Component({})
export default class EmapPanelEdit extends Vue {
    @Prop()  public eMapPanelEditObj?: any;
    @Prop()  public options?: any;

    public timer1: any;
    public timer2: any;
    public timer3: any;
    public timer4: any;
    public timer11: any;
    public timer12: any;
    public timer13: any;
    public timer14: any;
    private id: string = '';
    private editObj0: any = {
        /*         type:"",
                 linewidth:1,
                 iconOpacity:20,
                 borderColor:'#0000ff',
                 fillColor:'#0000ff',
                 inputDesc:'',
                 lineStyle:5,*/
    };
    private editObj1: any = {
        /*  type:"",
          textColor:'#555',
          fontDesc:'',
          inputFont:'文字示例',
          fontFamilyLi:'宋体',
          fontSizeLi:14,*/
    };
    private editObj2: any = {
        /*    type:"",
            inputFont:'文字示例',
            fontFamilyLi:'宋体',
            fontSizeLi:14,
            fontDesc:'',
            textColor:'#555',

            linewidth:1,
            lineColor:'#ffaeaa',
            iconOpacity:20,
            borderWidth:1,
            borderColor:'#13b5b1',
            fillColor:'#ffeda2',*/
    };
    private editObj3: any = {
        // scale :1,
        // iconOpacity:20,
        // inputDesc:'',
    };
    private linewidth = 1;
    private iconOpacity = 20;
    private inputDesc = '';
    private fontDesc = '';

    private text2Linewidth = 1;
    private text2Desc = '';
    private text2BorderWidth = 1;
    private text2Opacity = 20;

    // svg
    private scale = 1;
    private text3Desc = '';
    private text3Opacity = 0;

    private isShowOpacity = true;
    private isShowFill = false;
    private editSymbolType = -1;


    @Watch('editObj0', {deep: true})
    public onChange0(val: any) {
        const temp: any = {
            id: this.id,
            symbol: jQuery.extend(true, {}, val),
        };
        this.send(temp);

    }

    @Watch('editObj1', {deep: true})
    public onChange1(val: any) {
        const temp: any = {
            id: this.id,
            symbol: jQuery.extend(true, {}, val),
        };
        this.send(temp);
    }

    @Watch('editObj2', {deep: true})
    public onChange2(val: any) {
        const temp: any = {
            id: this.id,
            symbol: jQuery.extend(true, {}, val),
        };
        this.send(temp);
    }

    @Watch('editObj3', {deep: true})
    public onChange3(val: any) {
        const temp: any = {
            id: this.id,
            symbol: jQuery.extend(true, {}, val),
        };
        this.send(temp);
    }

    @Watch('eMapPanelEditObj', {deep: true})
    public onChange4(val: any) {
        if (val && val.data && val.data.id) {
            this.id = val.data.id;
            if (val.data.symbol.lineStyle) {
                val.data.symbol.lineStyle = val.data.symbol.lineStyle.toString();
            }
            if (val.key === 'SimpleLineSymbol') {
                this.editObj0 = Object.assign({}, val.data.symbol);
                this.linewidth = val.data.symbol.linewidth;
                this.iconOpacity = val.data.symbol.iconOpacity;
                this.inputDesc = val.data.symbol.inputDesc;
                this.editSymbolType = 0;
                this.$nextTick(() => {
                    this.isShowOpacity = true;
                    this.isShowFill = false;
                });
            } else if (val.key === 'SimpleFillSymbol' || val.key === 'composite' ) {
                this.editObj0 = Object.assign({}, val.data.symbol);
                this.linewidth = val.data.symbol.linewidth;
                this.iconOpacity = val.data.symbol.iconOpacity;
                this.inputDesc = val.data.symbol.inputDesc;
                this.$nextTick(() => {
                    this.isShowOpacity = true;
                    this.isShowFill = true;
                    this.editSymbolType = 0;
                });
            } else if (val.key === 'TextSymbol' ) {
                this.editObj1 = Object.assign({}, val.data.symbol);
                this.inputDesc = val.data.symbol.inputDesc;
                this.$nextTick(() => {
                    this.isShowOpacity = true;
                    this.editSymbolType = 1;
                });

            } else if (val.key === 'TailedText' ) {
                this.editObj2 = Object.assign({}, val.data.symbol);
                this.text2Linewidth = val.data.symbol.linewidth;
                this.text2BorderWidth = val.data.symbol.borderWidth;
                this.text2Opacity = val.data.symbol.iconOpacity;
                this.text2Desc = val.data.symbol.inputDesc;
                this.$nextTick(() => {
                    this.isShowOpacity = true;
                    this.editSymbolType = 2;
                });
            } else if (val.key === 'VectorMarkerSymbol') {
                // this.editObj3 = Object.assign({}, val.data.symbol);
                this.editObj3 = jQuery.extend(true, {}, val.data.symbol);
                this.scale = val.data.symbol.scale;
                this.text3Opacity = val.data.symbol.iconOpacity;
                this.text3Desc = val.data.symbol.inputDesc;
                this.$nextTick(() => {
                    this.isShowOpacity = true;
                    this.editSymbolType = 3;
                });
            }
        }
    }



    @Emit('eMapPanelEdit')
    public send(val: any) {
        return val;
    }

    @Emit('panelEditClose')
    public sendClose(val: any) {
        return val;
    }

    // input监听事件;
    // 线面线宽;
    public inputLinewidth(val: any) {
        if (val >= 150) {
            val = 150;
        }
        if (val <= 0) {
            val = 0;
        }
        this.linewidth = val;
        clearTimeout(this.timer2);
        this.timer2 = setTimeout(() => {
            this.editObj0.linewidth = val;
        }, 1000);
    }

    // 线面透明度 ;
    public inputIconOpacity(val: any) {
        if (val >= 255) {
            val = 255;
        }
        if (val <= 0) {
            val = 0;
        }
        this.iconOpacity = val;
        clearTimeout(this.timer3);
        this.timer3 = setTimeout(() => {
            this.editObj0.iconOpacity = val;
        }, 1000);
    }

    // 线面说明 ;
    public inputDescWatch(val: any) {
        clearTimeout(this.timer4);
        this.timer4 = setTimeout(() => {
            this.editObj0.inputDesc = val;
        }, 1000);
    }
    // 字体 ;
    public fontFamilyChange(val: any) {
        if (this.editSymbolType === 1) {
            $('.inputFont .el-textarea__inner').css('font-family', val);
        }
        if (this.editSymbolType === 2) {
            $('.inputFont2 .el-textarea__inner').css('font-family', val);
        }

    }

    // 字体说明 ;
    public fontDescWatch(val: any) {

        clearTimeout(this.timer1);
        this.timer1 = setTimeout(() => {
            this.editObj1.inputDesc = val;
        }, 1000);
    }

    // 线宽 ;
    public inputText2Linewidth(val?: any) {
        if (val >= 150) {
            val = 150;
        }
        if (val <= 0) {
            val = 0;
        }
        this.text2Linewidth = val;
        clearTimeout(this.timer11);
        this.timer11 = setTimeout(() => {
            this.editObj2.linewidth = val;
        }, 1000);
    }

    // 边框宽;
    public inputText2BorderWidth(val: any) {
        if (val >= 150) {
            val = 150;
        }
        if (val <= 0) {
            val = 0;
        }
        this.text2BorderWidth = val;
        clearTimeout(this.timer13);
        this.timer13 = setTimeout(() => {
            this.editObj2.borderWidth = val;
            $('.inputFont2 .el-textarea__inner').css('border-width', `${val}px`);
        }, 1000);
    }

    // 透明度;
    public inputText2Opacity(val: any) {
        if (val >= 255) {
            val = 255;
        }
        if (val <= 0) {
            val = 0;
        }
        this.text2Opacity = val;
        clearTimeout(this.timer14);
        this.timer14 = setTimeout(() => {
            this.editObj2.iconOpacity = val;
        }, 1000);
    }

    // 说明;
    public text2DescWatch(val: any) {

        clearTimeout(this.timer12);
        this.timer12 = setTimeout(() => {
            this.editObj2.fontDesc = val;
        }, 1000);
    }

    // svg符号
    // 缩放比例
    public inputTextScale(val: any) {
        if (val >= 10) {
            val = 10;
        }
        if (val <= 0) {
            val = 1;
        }
        this.scale = val;
        this.editObj3.scale = parseFloat(val);
    }

    // 透明度
    public inputText3Opacity(val: any) {
        if (val >= 255) {
            val = 255;
        }
        if (val <= 0) {
            val = 0;
        }
        this.text3Opacity = val;
        this.editObj3.iconOpacity = val;
    }

    // 说明
    public text3DescWatch(val: any) {
        this.text3Desc = val;
        this.editObj3.inputDesc = val;
    }

    // 关闭事件=;
    public closeClick(event: any ) {

        event.stopPropagation();
        event.preventDefault();
        const temp: any = false;
        this.sendClose(temp);
    }

    private created() {
        return false;
    }

    private mounted() {
        const eMapPanelDrag: any = new Drag('#eMapPanelEdit', '.eMapPanelEditTop', this.options.drag);
        eMapPanelDrag.toDrag();
    }

}
